/**
 * Mutación para asignar los procesos en segundo plano.
 */
export function setBackgroundProcess(state, backgroundProcess) {
    state.backgroundProcess = backgroundProcess
}


/**
 * Mutación para setear el tipo de agendamiento que se va a realizar.
 */
export function setType(state, type) {
    state.type = type
}

/**
 * Mutación para indicar si el reporte es global o no.
 */
export function setIsGlobalReport(state, isGlobalReport) {
    state.is_global_report = isGlobalReport
}

/**
 * Mutación para asignar las etiquetas procesadas por el usuario
 *
 */
export function setEtSheduling(state, type) {
    state.backgroundProcess = type.map((element) => {
        const temp = state.measures.find((medida) => medida.value === element.json.tipoEtiqueta);
        if (temp) {
            element.json.tipoEtiqueta = temp.text
        }
        return element
    });
}
